<div class="flex flex-col gap-4">
  <div class="text-surface-800 text-sm font-semibold font-['Inter']">TA Templates</div>
  @if (templateDatasource.hasTemplates()) {
    <div class="flex gap-2 items-center">
      <input type="text"
             pInputText
             [ngModel]="searchStr()"
             (ngModelChange)="searchStr.set($event)"
             class="w-1/2"
             pSize="small"
             placeholder="Type to filter by title or travel purpose..."
             data-testid="templates-search"
      />
      <div class="bg-white rounded-lg">
        <p-button outlined severity="secondary"
                  size="small"
                  (onClick)="searchStr.set('')">Clear</p-button>
      </div>
    </div>

    <div scrollHeight [bottomPadding]="100" class="rounded-lg border-[1px] border-surface-300 overflow-y-auto">
      <p-table [value]="filteredTemplates()"
               stripedRows
               [tableStyle]="{'min-width': '40rem'}"
               class="ta-list rounded-lg"
               data-testid="templates-table">
        <ng-template #header>
          <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed'] whitespace-nowrap">
            <th class="rounded-tl-lg">Title</th>
            <th>Primary Traveller</th>
            <th>Travel Purpose</th>
            <th>Destination</th>
            <th>No. Days</th>
            <th>Project Code</th>
            <th class="rounded-tr-lg ta-col-actions">Actions</th>
          </tr>
        </ng-template>
        <ng-template #body let-template let-rowIndex="rowIndex">
          @let isLast = rowIndex === filteredTemplates().length - 1;
          <tr class="text-xs font-normal font-['Roboto_Condensed'] cursor-pointer whitespace-nowrap"
              [ngClass]="{'!bg-primary-50': template.id === selectedId()}"
              (click)="selected.emit(template)"
              (dblclick)="editTemplate.emit(template)"
              data-testid="templates-row">
            <td [ngClass]="{'rounded-bl-lg': isLast}">
              <button class="text-primary-500 hover:underline font-semibold cursor-pointer"
                      (click)="editTemplate.emit(template); $event.stopPropagation()">
                {{ template.name }}
              </button>
            </td>
            <td>
              @if (template.primaryTravellerName) {
                <div class="flex gap-1 items-center">
                  @if (template.travellerCount > 1) {
                    <i class="fa-solid fa-users"></i>
                  } @else {
                    <i class="fa-solid fa-user"></i>
                  }
                  <span>{{ template.primaryTravellerName }}</span>
                </div>
              }
            </td>
            <td>{{ template.purpose }}</td>
            <td>
              @if (!!template.destinationName && locationService.outOfRegion(template.destinationName)) {
                <span class="text-purple-700 font-normal">{{ template.destinationName + ' ❖' }}</span>
              } @else {
                {{ template.destinationName }}
              }
            </td>
            <td>{{ template.dayCount }}</td>
            <td>{{ template.projectCode }}</td>
            <td class="ta-col-actions" [ngClass]="{'rounded-br-lg': isLast}">
              <div class="flex flex-col justify-start">
                <span class="flex" [pTooltip]="createDisabledMessage()" tooltipPosition="left">
                  <p-button label="Create TA from Template"
                            [style]="{height:'1.8em'}"
                            [text]="true"
                            severity="primary"
                            size="small"
                            [disabled]="createDisabled()"
                            (onClick)="$event.stopPropagation(); createTa.emit(template)"
                            data-testid="templates-row-create-ta"></p-button>
                </span>
                <p-button label="Edit Template"
                          [style]="{height:'1.8em'}"
                          [text]="true"
                          severity="primary"
                          size="small"
                          (onClick)="$event.stopPropagation(); editTemplate.emit(template)"
                          data-testid="templates-row-edit"></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #footer>
          @if (filteredTemplates().length === 0) {
            <tr class="text-xs font-normal font-['Roboto_Condensed']">
              <td class="rounded-bl-lg rounded-br-lg" colspan="7"><i>No results.</i></td>
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  } @else {
    <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6" data-testid="templates-empty">
      You have no templates. Select <b>Create a New Template</b> to make one.
    </div>
  }
</div>
